"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _underscore = require("underscore");

var _underscore2 = _interopRequireDefault(_underscore);

var _reactModal = require("react-modal");

var _reactModal2 = _interopRequireDefault(_reactModal);

var _location_320x = require("../../img/location_320x240.jpg");

var _location_320x2 = _interopRequireDefault(_location_320x);

var _reactGa = require("react-ga");

var _reactGa2 = _interopRequireDefault(_reactGa);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _locale = require("../../locale");

var _locale2 = _interopRequireDefault(_locale);

var _config = require("../../config");

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var GarageOverlay = function (_React$Component) {
  _inherits(GarageOverlay, _React$Component);

  function GarageOverlay(props) {
    _classCallCheck(this, GarageOverlay);

    return _possibleConstructorReturn(this, (GarageOverlay.__proto__ || Object.getPrototypeOf(GarageOverlay)).call(this, props));
  }

  _createClass(GarageOverlay, [{
    key: "render",
    value: function render() {
      var imageUrl = this.props.garage.ImageId ? _config2.default.getKey("imageUrl") + this.props.garage.ImageId : _location_320x2.default;
      return _react2.default.createElement("div", {
        className: "overlay"
      }, _react2.default.createElement("div", null, _react2.default.createElement("div", null, "Informationen zum Standort:"), _react2.default.createElement("div", null, _react2.default.createElement("img", {
        src: imageUrl,
        width: "340px"
      })), _react2.default.createElement("div", null, _react2.default.createElement("p", {
        className: "name"
      }, this.props.garage.Name), _react2.default.createElement("p", null, this.props.garage.Address, ", ", this.props.garage.ZipCode, " ", this.props.garage.City), _react2.default.createElement("div", null, _react2.default.createElement("table", null, _react2.default.createElement("tbody", null, _react2.default.createElement("tr", null, _react2.default.createElement("td", {
        className: "org",
        colSpan: "2"
      }, "Kontakt")), _react2.default.createElement("tr", null, _react2.default.createElement("td", {
        className: "org"
      }, "Telefon:"), _react2.default.createElement("td", null, _react2.default.createElement("a", {
        href: "tel:" + this.props.garage.Phone
      }, this.props.garage.Phone))), _react2.default.createElement("tr", null, _react2.default.createElement("td", {
        className: "org"
      }, "E-Mail:"), _react2.default.createElement("td", null, _react2.default.createElement("a", {
        href: "mailto:" + this.props.garage.Email
      }, this.props.garage.Email)))))), _react2.default.createElement("div", null, _react2.default.createElement("table", null, _react2.default.createElement("tbody", null, _react2.default.createElement("tr", null, _react2.default.createElement("td", {
        colSpan: "4",
        className: "org"
      }, "\xD6ffnungszeiten:")), _react2.default.createElement("tr", null, _react2.default.createElement("td", {
        className: "org"
      }, this.props.garage.OpeningHours.Desc)))))), _react2.default.createElement("div", null, _react2.default.createElement("a", {
        className: "link ico close",
        onClick: this.props.onClose
      }, "Fenster schlie\xDFen"))));
    }
  }]);

  return GarageOverlay;
}(_react2.default.Component);

var GarageSelector = function (_React$Component2) {
  _inherits(GarageSelector, _React$Component2);

  function GarageSelector(props) {
    _classCallCheck(this, GarageSelector);

    var _this2 = _possibleConstructorReturn(this, (GarageSelector.__proto__ || Object.getPrototypeOf(GarageSelector)).call(this, props));

    _this2.state = {
      modal: false,
      id: _underscore2.default.uniqueId("prefix-")
    };
    return _this2;
  }

  _createClass(GarageSelector, [{
    key: "openGarageInfo",
    value: function openGarageInfo(garage) {
      this.setState({
        modal: true
      });
    }
  }, {
    key: "closeModal",
    value: function closeModal() {
      this.setState({
        modal: false
      });
    }
  }, {
    key: "getParent",
    value: function getParent() {
      return document.querySelector('#otr');
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var imageUrl = this.props.garage.ImageId ? _config2.default.getKey("imageUrl") + this.props.garage.ImageId : _location_320x2.default;
      return _react2.default.createElement("div", {
        className: "group garage"
      }, _react2.default.createElement("div", {
        className: "line"
      }, _react2.default.createElement("div", {
        className: "txt"
      }, _react2.default.createElement("div", {
        className: "img local"
      }, _react2.default.createElement("img", {
        src: imageUrl
      })), _react2.default.createElement("p", null, this.props.garage.Name, _react2.default.createElement("span", {
        className: "address"
      }, this.props.garage.Address, ", ", this.props.garage.ZipCode, " ", this.props.garage.City), _react2.default.createElement("div", null, _react2.default.createElement("table", {
        className: "openHours"
      }, _react2.default.createElement("tbody", null, _react2.default.createElement("tr", null, _react2.default.createElement("td", {
        colSpan: "4",
        className: "openHoursLine"
      }, "\xD6ffnungszeiten:")), _react2.default.createElement("tr", null, _react2.default.createElement("td", {
        className: "openHoursLine"
      }, this.props.garage.OpeningHours.Desc))))))), _react2.default.createElement("div", {
        className: "right"
      }, _react2.default.createElement("a", {
        className: "info",
        onClick: function onClick() {
          return _this3.openGarageInfo(_this3.props.garage);
        }
      }), _react2.default.createElement(_reactModal2.default, {
        parentSelector: this.getParent,
        isOpen: this.state.modal,
        contentLabel: "Modal",
        className: "myModal",
        overlayClassName: "myOverlay"
      }, _react2.default.createElement(GarageOverlay, {
        garage: this.props.garage,
        onClose: this.closeModal.bind(this)
      })), _react2.default.createElement("button", {
        className: "btn",
        type: "button",
        id: this.state.id,
        onClick: this.props.onSelect
      }, "w\xE4hlen"))));
    }
  }]);

  return GarageSelector;
}(_react2.default.Component);

var GarageSelection = function (_React$Component3) {
  _inherits(GarageSelection, _React$Component3);

  function GarageSelection(props) {
    _classCallCheck(this, GarageSelection);

    var _this4 = _possibleConstructorReturn(this, (GarageSelection.__proto__ || Object.getPrototypeOf(GarageSelection)).call(this, props));

    _this4.state = {
      valid: false,
      selectedGarage: props.selectedGarage
    };
    return _this4;
  }

  _createClass(GarageSelection, [{
    key: "getFormData",
    value: function getFormData() {
      return {
        stepId: "garage",
        formData: {
          garageId: this.state.selectedGarage
        }
      };
    }
  }, {
    key: "componentWillMount",
    value: function componentWillMount() {
      _reactGa2.default.event({
        category: "OTB",
        action: "Step",
        label: "Garage"
      });
    }
  }, {
    key: "onSelectGarage",
    value: function onSelectGarage(garage) {
      var _this5 = this;

      this.setState({
        selectedGarage: garage.Id
      }, function () {
        if (garage) {
          _this5.props.submit("garage", {
            garageId: garage.Id
          });
        } else {
          _this5.props.disableSubmit();
        }
      });
    }
  }, {
    key: "renderSelectorList",
    value: function renderSelectorList() {
      var _this6 = this;

      var selectors = [];

      var _loop = function _loop(garageId) {
        var garage = _this6.props.garages[garageId];
        selectors.push(_react2.default.createElement(GarageSelector, {
          isSelected: _this6.state.selectedGarage == garageId,
          onSelect: function onSelect() {
            return _this6.onSelectGarage(garage);
          },
          key: garageId,
          garage: garage
        }));
      };

      for (var garageId in this.props.garages) {
        _loop(garageId);
      }

      return selectors;
    }
  }, {
    key: "render",
    value: function render() {
      return _react2.default.createElement("div", null, _react2.default.createElement("div", {
        dangerouslySetInnerHTML: {
          __html: _locale2.default.getResource("otb_GarageSelectionText")
        }
      }), _react2.default.createElement("div", {
        className: "sub"
      }, "Auswahl Standort"), this.renderSelectorList());
    }
  }]);

  return GarageSelection;
}(_react2.default.Component);

GarageSelection.propTypes = {
  selectedGarage: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  garages: _propTypes2.default.object.isRequired,
  submit: _propTypes2.default.func.isRequired,
  loadGarages: _propTypes2.default.func.isRequired
};
exports.default = GarageSelection;